'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _latlng = require('./latlng');

var _latlng2 = _interopRequireDefault(_latlng);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.shape({
  center: _latlng2.default,
  zoom: _propTypes2.default.number
});


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/lib/propTypes/viewport.js
// module id = 1099
// module chunks = 70144966829960